module.exports = __webpack_public_path__ + "static/media/pp.1f8f48a5.png";